import { type FC, useCallback } from "react";

import { cloneDeep, isEmpty, isEqual, pickBy } from "lodash-es";
import { useFormContext } from "react-hook-form";
import type { MomentFormMoment } from "../../moment/types/moment-form-moment";
import { LeavePageConfirm } from "./leave-page-confirm";

export const LeaveMomentPageContext: FC<{ debug?: boolean }> = ({ debug }) => {
  const {
    formState: { dirtyFields, defaultValues },
    getValues,
  } = useFormContext<MomentFormMoment>();

  const { design } = defaultValues ?? { design: undefined };

  const confirmCallback = useCallback(() => {
    const dirtyFieldsToIgnore = ["running", "sent", "design"];
    const dirtyFieldsWithoutIgnored = pickBy(
      dirtyFields,
      (v, k) => Boolean(v) && !dirtyFieldsToIgnore.includes(k),
    );

    if (debug) {
      console.log({
        dirtyFieldsWithoutIgnored: cloneDeep(dirtyFieldsWithoutIgnored),
        defaultValuesDesign: JSON.parse(JSON.stringify(design)) as unknown,
        getValuesDesign: JSON.parse(JSON.stringify(getValues("design"))) as unknown,
      });
    }

    return (
      !isEmpty(dirtyFieldsWithoutIgnored) ||
      // The prototype of the design object does not allow us to use isEqual or a traditional
      // deep comparison. So we ignore the dirty check for the design field and instead compare
      // manually by first stringifying the objects and then parsing them back into JSON.
      !isEqual(JSON.parse(JSON.stringify(design)), JSON.parse(JSON.stringify(getValues("design"))))
    );
  }, [dirtyFields, debug, getValues, design]);

  return (
    <LeavePageConfirm enabled={confirmCallback}>
      You have unsaved changes, are you sure you wish to leave the page?
    </LeavePageConfirm>
  );
};
